<template>
  <div class="inventoryTransferDetail">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <h2 style="margin-right: 20px;">{{ data.inventoryTransfer.id ? '编辑' : '新增' }}调拨</h2>
        <el-button-group>
          <el-button @click="router.go(-1)">返回</el-button>
          <el-button type="primary" @click="save()" :loading="show.saving">保存</el-button>
        </el-button-group>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="调拨日期">
            <el-date-picker style="width: 100%;" v-model="data.inventoryTransfer.transferDate" type="date" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="煤矿品名">
            <el-select v-model="data.inventoryTransfer.product" filterable @change="loadOutInventory()">
              <el-option v-for='productItem in show.productList' :key="productItem.id" :label="productItem.value" :value="productItem.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调出仓储">
            <el-select v-model="data.inventoryTransfer.outStorage" filterable @change="loadOutInventory(); findTransDedSaleFormula()">
              <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调入仓储">
            <el-select v-model="data.inventoryTransfer.inStorage" filterable>
              <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="调出数量">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.inventoryTransfer.outQuantity" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="调入数量">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.inventoryTransfer.inQuantity" @change="computeTransferTransportAmountAfterDeduction()" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="亏吨">
            <el-text>{{ math.formatNumber(lossQuantity()) }}</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="调出仓储库存">
            <el-text v-if="show.outInventory">
              当前库存 {{ math.formatNumber(show.outInventory.quantity) }} 吨，
              加权平均煤款单价 {{ math.formatNumber(show.outInventory.productPrice) }}，
              加权平均运费单价 {{ math.formatNumber(show.outInventory.transportPrice) }}
            </el-text>
            <el-text type="danger" v-else-if="data.inventoryTransfer.outStorage && data.inventoryTransfer.product">
              该仓储下没有此煤矿品名的库存
            </el-text>
            <el-text type="info" v-else>请先选择煤矿品名与调出仓储</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调出单价">
            <el-text>{{ math.formatNumber(outProductPrice()) }}</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调出运费单价">
            <el-text>{{ math.formatNumber(outTransportPrice()) }}</el-text>
          </el-form-item>
        </el-col>
        <el-divider content-position="left">运费</el-divider>
        <el-col :span="12">
          <el-tooltip effect="dark" content="本次调拨新发生的运费单价，按调入数量计价" placement="bottom">
            <el-form-item label="运费单价">
              <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.inventoryTransfer.transferTransportPrice" @change="computeTransferTransportAmountAfterDeduction()" />
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小计">
            <el-text style="width: 100%;text-align: center;">{{ math.formatNumber(math.multiply(data.inventoryTransfer.inQuantity, data.inventoryTransfer.transferTransportPrice)) }}</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="运费扣除">
            <el-input-number style="width: calc(100% - 70px)" :controls="false" :precision="2" v-model="data.inventoryTransfer.transferTransportDeductionAmount" @change="computeTransferTransportAmountAfterDeduction()" />
            <el-link type="primary" style="margin-left: 20px;" @click="show.transDedAmountFormulaDialog = true">公式</el-link>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实付运费">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.inventoryTransfer.transferTransportAmountAfterDeduction" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务费">
            <el-input-number style="width: calc(100% - 70px)" :controls="false" :precision="2" v-model="data.inventoryTransfer.transferTransportServiceAmount" @change="computeTransferTransportAmount()" />
            <el-link type="primary" style="margin-left: 20px;" @click="show.transServAmountFormulaDialog = true">公式</el-link>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-tooltip effect="dark" content="实付运费+服务费，即本次调拨新发生的运费，参与调入仓储的加权平均" placement="bottom">
            <el-form-item label="运费合计">
              <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.inventoryTransfer.transferTransportAmount" />
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-divider content-position="left">成本</el-divider>
        <el-col :span="12">
          <el-form-item label="总成本">
            <el-text>{{ math.formatNumber(productAmount()) }}</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调入单价">
            <el-text>{{ math.formatNumber(math.divide(productAmount(), data.inventoryTransfer.inQuantity)) }}</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="总运费">
            <el-text>{{ math.formatNumber(transportAmount()) }}</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调入运费单价">
            <el-text>{{ math.formatNumber(math.divide(transportAmount(), data.inventoryTransfer.inQuantity)) }}</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-text type="info">
              调出单价、调出运费单价按<b>保存那一刻</b>调出仓储的加权平均成本取值，与调拨日期无关；保存后调出仓储扣减库存、调入仓储按总成本与总运费重新加权平均。
              总运费 = 调出数量 × 调出运费单价 + <b>运费合计</b>。
            </el-text>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>

  <el-dialog v-model="show.transDedAmountFormulaDialog" title="选择运费扣除公式（下游运费扣除）" width="650">
    <el-table :data="show.transDedAmountFormulaList" :show-header="false">
      <el-table-column prop="name">
        <template #default="scope">
          <el-text v-show="!scope.row.default">{{ scope.row.name }}</el-text>
          <el-text v-show="scope.row.default" type="primary">{{ '【默认】' + scope.row.name }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="btn" width="200">
        <template #default="scope">
          <el-button-group>
            <el-button type="primary" @click="useTransDedAmountFormula(scope.row)">使用</el-button>
            <el-button @click="useTransDedAmountFormulaAndSetDefault(scope.row)">并标记默认</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>

  <el-dialog v-model="show.transServAmountFormulaDialog" title="选择服务费公式（下游运费服务费）" width="650">
    <!-- 调拨单上没有运输公司，服务费公式的默认值是按运输公司记的，这里只能选用、不能标记默认 -->
    <el-table :data="show.transServAmountFormulaList" :show-header="false">
      <el-table-column prop="name">
        <template #default="scope">
          <el-text>{{ scope.row.name }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="btn" width="100">
        <template #default="scope">
          <el-button type="primary" @click="useTransServAmountFormula(scope.row)">使用</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script setup>
import { reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const show = reactive({
  saving: false,
  storageList: [],
  productList: [],
  outInventory: null,
  transDedAmountFormulaList: [],
  transServAmountFormulaList: [],
  transDedAmountFormulaDialog: false,
  transServAmountFormulaDialog: false,
})
const pageParam = cache.getObject(cache.keys.pageParam + "inventoryTransferDetail")
const data = reactive({
  inventoryTransfer: pageParam ? JSON.parse(JSON.stringify(pageParam)) : {
    transferTransportPrice: 0,
    transferTransportDeductionAmount: 0,
    transferTransportAmountAfterDeduction: 0,
    transferTransportServiceAmount: 0,
    transferTransportAmount: 0,
  }
})

api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})
api.get('/backend/dict/getByCode', { params: { code: 'product' } }).then(res => {
  show.productList = res.dictList
})

/** 运费扣除公式：沿用销售的「下游运费扣除」，默认公式按调出仓储记（与销售明细共用同一份仓储默认） */
const findTransDedSaleFormula = () => {
  const formulaParam = {
    model: 'transDedSale'
  }
  if (data.inventoryTransfer.outStorage) {
    formulaParam.defaultKey = data.inventoryTransfer.outStorage
  }
  api.get('/backend/formula/get', { params: formulaParam }).then(res => {
    show.transDedAmountFormulaList = res.list
    if (res.data && res.data.default) {
      for (let formula of show.transDedAmountFormulaList) {
        if (formula.id == res.data.default.id) {
          formula.default = true
        }
      }
    }
  })
}
findTransDedSaleFormula()

/** 服务费公式：沿用销售的「下游运费服务费」，调拨单没有运输公司，所以不取默认公式 */
const findTransServSaleFormula = () => {
  api.get('/backend/formula/get', { params: { model: 'transServSale' } }).then(res => {
    show.transServAmountFormulaList = res.list
  })
}
findTransServSaleFormula()

/** 取调出仓储该品名的实时库存与加权平均成本 */
const loadOutInventory = () => {
  show.outInventory = null
  const outStorage = data.inventoryTransfer.outStorage
  const product = data.inventoryTransfer.product
  if (!outStorage || !product) {
    return
  }
  api.get('/backend/inventory/list', { params: { storage: outStorage, product: product } }).then(res => {
    show.outInventory = res.list && res.list.length > 0 ? res.list[0] : null
  })
}
loadOutInventory()

/** 调出单价：以调出仓储当前的加权平均煤款单价为准，取不到时回落到单据上已记录的值 */
const outProductPrice = () => {
  return show.outInventory ? show.outInventory.productPrice : data.inventoryTransfer.outProductPrice
}

const outTransportPrice = () => {
  return show.outInventory ? show.outInventory.transportPrice : data.inventoryTransfer.outTransportPrice
}

/** 亏吨 = 调出数量 - 调入数量 */
const lossQuantity = () => {
  return math.plus(data.inventoryTransfer.outQuantity, -data.inventoryTransfer.inQuantity)
}

/** 总成本 = 调出数量 * 调出单价 */
const productAmount = () => {
  return math.multiply(data.inventoryTransfer.outQuantity, outProductPrice())
}

/** 总运费 = 调出数量 * 调出运费单价 + 运费合计 */
const transportAmount = () => {
  return math.plus(math.multiply(data.inventoryTransfer.outQuantity, outTransportPrice()), data.inventoryTransfer.transferTransportAmount)
}

/** 实付运费 = 调入数量 * 运费单价 - 运费扣除，向下抹到十位（与销售明细（到达）一致） */
const computeTransferTransportAmountAfterDeduction = () => {
  if (data.inventoryTransfer.inQuantity && data.inventoryTransfer.transferTransportPrice) {
    let amountAfterDeduction = math.plus(math.multiply(data.inventoryTransfer.inQuantity, data.inventoryTransfer.transferTransportPrice), -(data.inventoryTransfer.transferTransportDeductionAmount || 0))
    amountAfterDeduction = math.floor(amountAfterDeduction, -1)
    if (data.inventoryTransfer.transferTransportAmountAfterDeduction != amountAfterDeduction) {
      data.inventoryTransfer.transferTransportAmountAfterDeduction = amountAfterDeduction
      computeTransferTransportAmount()
    }
  }
}

/** 运费合计 = 实付运费 + 服务费 */
const computeTransferTransportAmount = () => {
  data.inventoryTransfer.transferTransportAmount = math.plus(data.inventoryTransfer.transferTransportServiceAmount, data.inventoryTransfer.transferTransportAmountAfterDeduction)
  ElMessage.success('运费已自动更新')
}

const useTransDedAmountFormulaAndSetDefault = (formula) => {
  if (!data.inventoryTransfer.outStorage) {
    ElMessage.error('没有选择调出仓储，无法设置默认公式')
    return
  }
  api.post('/backend/formula/setDefault', {
    model: 'transDedSale',
    key: data.inventoryTransfer.outStorage,
    formulaId: formula.id
  }).then(() => {
    ElMessage.success('公式已设为' + data.inventoryTransfer.outStorage + '默认')
    useTransDedAmountFormula(formula)
  })
}

const useTransDedAmountFormula = (formula) => {
  try {
    let 结果 = null
    const 调出数量 = data.inventoryTransfer.outQuantity || 0
    const 调入数量 = data.inventoryTransfer.inQuantity || 0
    const 亏吨 = lossQuantity()
    // 下游运费公式里的销售变量：能对上的按调拨字段喂，调拨没有的一律给0，公式不改也能直接用
    const 重车数量 = 0
    const 皮重数量 = 0
    const 涨吨数量 = 0
    const 退车数量 = 0
    const 出库数量 = 调出数量
    const 库存扣减 = 调出数量
    const 到货数量 = 调入数量
    const 运输亏吨 = 亏吨
    const 最终验收 = 调入数量
    const 实付运费 = data.inventoryTransfer.transferTransportAmountAfterDeduction || 0
    console.info('调出数量', 调出数量, '调入数量', 调入数量, '亏吨', 亏吨, '重车数量', 重车数量, '皮重数量', 皮重数量, '出库数量', 出库数量, '涨吨数量', 涨吨数量, '退车数量', 退车数量, '库存扣减', 库存扣减, '到货数量', 到货数量, '运输亏吨', 运输亏吨, '最终验收', 最终验收, '实付运费', 实付运费)
    eval(formula.jsScript)
    if (结果 === null) {
      ElMessage.error('公式有误，请手动填写')
      return
    }
    data.inventoryTransfer.transferTransportDeductionAmount = math.halfUp(结果, 2)
    computeTransferTransportAmountAfterDeduction()
    show.transDedAmountFormulaDialog = false
  } catch (error) {
    ElMessage.error('公式有误，请手动填写')
    console.error(error)
  }
}

const useTransServAmountFormula = (formula) => {
  try {
    let 结果 = null
    const 调出数量 = data.inventoryTransfer.outQuantity || 0
    const 调入数量 = data.inventoryTransfer.inQuantity || 0
    const 亏吨 = lossQuantity()
    const 重车数量 = 0
    const 皮重数量 = 0
    const 涨吨数量 = 0
    const 退车数量 = 0
    const 出库数量 = 调出数量
    const 库存扣减 = 调出数量
    const 到货数量 = 调入数量
    const 运输亏吨 = 亏吨
    const 最终验收 = 调入数量
    const 实付运费 = data.inventoryTransfer.transferTransportAmountAfterDeduction || 0
    console.info('调出数量', 调出数量, '调入数量', 调入数量, '亏吨', 亏吨, '重车数量', 重车数量, '皮重数量', 皮重数量, '出库数量', 出库数量, '涨吨数量', 涨吨数量, '退车数量', 退车数量, '库存扣减', 库存扣减, '到货数量', 到货数量, '运输亏吨', 运输亏吨, '最终验收', 最终验收, '实付运费', 实付运费)
    eval(formula.jsScript)
    if (结果 === null) {
      ElMessage.error('公式有误，请手动填写')
      return
    }
    data.inventoryTransfer.transferTransportServiceAmount = math.halfUp(结果, 2)
    computeTransferTransportAmount()
    show.transServAmountFormulaDialog = false
  } catch (error) {
    ElMessage.error('公式有误，请手动填写')
    console.error(error)
  }
}

const save = () => {
  if (show.saving) {
    return
  }
  const param = JSON.parse(JSON.stringify(data.inventoryTransfer))
  if (!param.transferDate) {
    ElMessage.error('请选择调拨日期')
    return
  }
  if (!param.outStorage || !param.inStorage || !param.product) {
    ElMessage.error('请选择调出仓储、调入仓储与煤矿品名')
    return
  }
  if (param.outStorage == param.inStorage) {
    ElMessage.error('调出仓储与调入仓储不能相同')
    return
  }
  if (!(param.outQuantity > 0)) {
    ElMessage.error('调出数量必须大于0')
    return
  }
  if (!(param.inQuantity > 0)) {
    ElMessage.error('调入数量必须大于0')
    return
  }
  param.transferDate = util.parseTime(param.transferDate, '{y}-{m}-{d}')
  param.transferTransportPrice = param.transferTransportPrice || 0
  param.transferTransportDeductionAmount = param.transferTransportDeductionAmount || 0
  param.transferTransportAmountAfterDeduction = param.transferTransportAmountAfterDeduction || 0
  param.transferTransportServiceAmount = param.transferTransportServiceAmount || 0
  param.transferTransportAmount = param.transferTransportAmount || 0
  param.operateUser = null
  param.createDatetime = null
  param.operateDatetime = null
  param.lossQuantity = null
  param.outProductPrice = null
  param.outTransportPrice = null
  show.saving = true
  if (param.id) {
    api.post('/backend/inventoryTransfer/setById', param).then(() => {
      ElMessage.success('保存成功')
      router.go(-1)
    }).finally(() => {
      show.saving = false
    })
  } else {
    api.post('/backend/inventoryTransfer/add', param).then(() => {
      ElMessage.success('保存成功')
      router.go(-1)
    }).finally(() => {
      show.saving = false
    })
  }
}
</script>

<style lang="less">
.inventoryTransferDetail {
  margin: auto;
  max-width: 900px;
}
</style>
